import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';
import { ApiKeyTemplate } from 'types/apiKeyTemplate';

/**
 * APIキーテンプレート一覧画面の状態
 */
interface ListState {
  /**
   * ロード中フラグ
   */
  loading: boolean;
  /**
   * APIキーテンプレート一覧
   */
  apiKeyTemplates: ApiKeyTemplate[];
  /**
   * 選択されたリリース
   */
  selectedApiKeyTemplate: ApiKeyTemplate | undefined;
}

/**
 * APIキーテンプレート一覧画面の初期状態
 */
const initialState: ListState = {
  loading: false,
  apiKeyTemplates: [],
  selectedApiKeyTemplate: undefined,
};

/**
 * APIキーテンプレート画面の slice(reducer + action)
 */
export const listSlice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    init: () => initialState,
    loadStarted: (state) => {
      state.loading = true;
    },
    loadEnded: (state) => {
      state.loading = false;
    },
    fetchApiKeyTemplateSuccess: (
      state,
      action: PayloadAction<{
        apiKeyTemplates: ApiKeyTemplate[];
      }>,
    ) => {
      const { apiKeyTemplates } = action.payload;
      state.apiKeyTemplates = apiKeyTemplates;
    },
  },
});

/**
 * APIキーテンプレート一覧画面の action
 */
export const listActions = listSlice.actions;

/**
 * APIキーテンプレート一覧画面の selector（内部用）
 */
const getloading = (state: RootState) => state.apiKeyTemplate.list.loading;

const getApiKeyTemplates = (state: RootState) =>
  state.apiKeyTemplate.list.apiKeyTemplates;

/**
 * APIキーテンプレート一覧画面の selector
 */
export const listSelectors = {
  loading: getloading,
  apiKeyTemplates: getApiKeyTemplates,
} as const;
